// extracted by mini-css-extract-plugin
export var closed = "_bj-1";
export var resizer = "_bj-0";